/* eslint-disable no-restricted-imports */
import React, {useEffect, useMemo, useState} from "react";
import {ButtonGroup, Dropdown, Modal} from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {ModalProgressBar} from "../../../../_metronic/_partials/controls";
import * as actions from "../../ProjectProposals/_redux/actions";
import * as emyProjectActions from "../_redux/actions";
import { useModuleContext } from "../ModuleContext";
import {CONTEXT} from "../../ProjectProposals/util/ModuleHelpers";
import {AEButton} from "../../../../_emywork/components/buttons";
import {EntityCard} from "../componants/EntityCard";
import {EntityCard as UserEntityCard} from "../../Users/componants/EntityCard";
import {AEFileDownload} from "../../../../_emywork/components/AEFileDownload";
import {actionTypes} from "../../ProjectProposals/_redux/slice";
import {AEMetadata} from "../../../../_emywork/AEPagination";
import {AECurrency} from "../../../../_emywork/components/Currency";
import {useIntl} from "react-intl";
import {PAYMENT_TERMS, PROPOSALS} from "../../../../_emywork/helpers/UIHelper";
import {EmyProjectStatus, EmyProposalStatus} from "../componants/Status";
import {HTTP_UPDATED} from "../../../../_emywork/helpers/AxiosHelpers";
import {getConfig} from "../../../../_metronic/i18n";
import {getProposalStatus, getProposalStatuses, getStatusesKeys, PROPOSAL_STATUSES} from "../helpers/StatusHelpers";
import {AERole} from "../../../../_emywork/components/AERole";
import {roles} from "../../../App";




//TODO
export function ProposalDetailsModal({onSave = ()=>{}}) {
  const [rejectModalShow, setRejectModalShow] = useState(false);
  const UIContext = useModuleContext();
  const {formatMessage} = useIntl();
  const {role} = getConfig();
  const {show, close, id} = useMemo(() => {
    return {
      show: UIContext.proposalDetailsModalShow,
      close: UIContext.closeProposalDetailsDialog,
      id: UIContext.idForProposalDetails,
    };
  }, [UIContext]);


  const dispatch = useDispatch();
  const { isLoading, entity } = useSelector(
    (state) => ({
      isLoading: state[CONTEXT][actionTypes.Details].isLoading,
      entity: state[CONTEXT][actionTypes.Details].entity,
    }),
    shallowEqual
  );

  // console.log("error", error)

  useEffect(() => {
    dispatch(actions.fetchEntity(id,new AEMetadata({},{},{},
      ['*','created_by','attachments','project','project.category','project.subcategory','project.payment_term']
    ),actionTypes.Details));
  }, [id, dispatch]);

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  const update = (_entity) => {
    dispatch(actions.updateEntity({id, ..._entity})).then(() => {
      dispatch(emyProjectActions.fetchEntity());
      onSave()
      close();
      setRejectModalShow(false);
    });
  };


  const currentStatus = getProposalStatus(entity.status);
  const allowedStatuses = currentStatus.roles.includes(role) ?
    currentStatus.allowed.filter(key=>PROPOSAL_STATUSES[key].roles.includes(role)) :
    []

  return (
    <>
      <Modal show={rejectModalShow} >
        <Modal.Header closeButton>
          <Modal.Title>{formatMessage({id:"PROPOSAL.REJECT_MODAL.TITLE"})}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span dangerouslySetInnerHTML={{__html:formatMessage({id:"PROPOSAL.REJECT_MODAL.MESSAGE"},{username: entity.created_by ? entity.created_by.username : "user"})}} />
        </Modal.Body>
        <Modal.Footer>
          <AEButton variant={'light'} onClick={e=>{setRejectModalShow(false)}} >
            {formatMessage({id:'CANCEL'})}
          </AEButton>
          <AEButton variant={'light-secondary'} onClick={()=>{
            update({status:PROPOSALS.REJECTED}) //todo
          }} >
            {formatMessage({id:'REJECT'})}
          </AEButton>
        </Modal.Footer>
      </Modal>


      <Modal size="lg" show={show} onHide={close} >
        {isLoading && <ModalProgressBar variant="query" />}
        {/*<Modal.Header>*/}
        {/*  <Modal.Title>*/}
        {/*    Proposal Details*/}
        {/*  </Modal.Title>*/}
        {/*</Modal.Header>*/}
        <Modal.Body>
          {entity.id && (
            <>
              <div className='d-lg-flex'>
                <div className="flex-lg-fill">
                  <UserEntityCard
                    entity={entity.created_by}
                    size={"xs"}
                    className={'mb-0'}
                  />
                </div>
                <div className="flex-lg-fill">
                  <EntityCard entity={entity.project} size={'xs'}/>
                </div>
              </div>
              {/*todo clean*/}
              <div className="font-weight-bold text-dark pt-5 mb-4">
                <h4> {formatMessage({id:'PRICE'})} </h4>
                <div className="h5">
                  <AECurrency value={entity.price} />
                  <span className="text-muted">{[PAYMENT_TERMS.HOURLY].includes(entity.project.payment_term._key) && " Per hour"}</span>
                </div>
              </div>
              <div className="text-dark-50 line-height-lg mb-8">
                { entity.note }
              </div>
              {
                entity.attachments.length > 0 &&
                <div>
                  <h4> {formatMessage({id:'ATTACHMENTS'})} </h4>
                  {
                    entity.attachments.map(({id,file_name})=>(
                      <div key={id}>
                        <AEFileDownload id={id} target={'project_proposal_attachments'} fileName={file_name} />
                      </div>
                    ))
                  }
                </div>
              }
              <div className="d-flex justify-content-end align-items-baseline">
                <AEButton variant={'light'} onClick={close} >
                  {formatMessage({id:'CLOSE'})}
                </AEButton>
                <div className={'pl-2'}>
                  <Dropdown as={ButtonGroup}>
                    <AEButton variant={currentStatus.className}>
                      {formatMessage({id : entity.status})}
                    </AEButton>

                    {
                      allowedStatuses.length > 0 &&
                      <>
                        <Dropdown.Toggle split variant={currentStatus.className} />
                        <Dropdown.Menu className={"py-5"}>
                          {
                            allowedStatuses
                              .map(key=>(
                                <Dropdown.Item
                                  key={key}
                                  onClick={() => {
                                    update({status: key})
                                  }}>
                                  <EmyProposalStatus status={key}/>
                                </Dropdown.Item>
                              ))
                          }
                        </Dropdown.Menu>
                      </>
                    }
                  </Dropdown>
                  <div className='text-muted text-center font-size-sm'>
                    {formatMessage({id:'ROLE_CLIENT'})}
                  </div>
                </div>

                <div className={'pl-2'}>
                  <Dropdown as={ButtonGroup}>
                    <AEButton
                      variant={getProposalStatus(entity.provider_status).className}
                    >
                      {formatMessage({id : entity.provider_status})}
                    </AEButton>
                    <AERole accept={[roles.super_admin, roles.provider]}>
                      <Dropdown.Toggle split variant={getProposalStatus(entity.provider_status).className} />
                      <Dropdown.Menu className={"py-5"}>
                        {
                          ['COMPLETED', 'CANCELLED']
                            .map(key=>(
                              <Dropdown.Item
                                key={key}
                                onClick={() => {
                                  update({provider_status: key})
                                }}>
                                <EmyProposalStatus status={key}/>
                              </Dropdown.Item>
                            ))
                        }
                      </Dropdown.Menu>
                    </AERole>

                  </Dropdown>
                  <div className='text-muted text-center font-size-sm'>
                    {formatMessage({id:'ROLE_PROVIDER'})}
                  </div>
                </div>
              </div>
            </>
          )}
          {/*{isLoading && <span>Sending ...</span>}*/}




        </Modal.Body>
        {/*<Modal.Footer>*/}
        {/*  */}

        {/*</Modal.Footer>*/}
      </Modal>
    </>

  );
}
